module.exports = __webpack_public_path__ + "img/walking.16e1e3fc.jpg";